import { FunctionComponent } from 'react'
import Blink from '@components/Blink'
import styled, { css } from 'styled-components'
import { CreditProps } from '@widgets/ArticleTextbox/types'
import useIsInHerotellingPage from '@hooks/useIsInHerotellingPage'
import { mobileAndTabletCSS } from '@measures/responsive'

type StyledCreditProps = {
  isInHerotellingPage: boolean
}

const StyledCredit = styled.div<StyledCreditProps>`
  ${({
    theme: {
      colors: { textWeak, staticNeutral400 },
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodycopyCSS },
        },
      },
    },
    isInHerotellingPage,
  }) => css`
    font-weight: normal;
    color: ${textWeak};
    ${xxsmallBodycopyCSS}

    ${isInHerotellingPage &&
    css`
      text-align: center;
      color: ${staticNeutral400};
      ${mobileAndTabletCSS(css`
        order: -1;
      `)};
    `}
  `}
`

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodycopyCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    font-weight: normal;
    color: ${textDefault};
    text-decoration: underline;
    cursor: pointer;

    ${xxsmallBodycopyCSS}
  `}
`

const Credit: FunctionComponent<CreditProps> = ({ blinkProps, children }) => {
  const isInHerotellingPage = useIsInHerotellingPage()
  if (blinkProps?.href) {
    return <StyledBlink {...blinkProps}>{children}</StyledBlink>
  }

  return (
    <StyledCredit isInHerotellingPage={isInHerotellingPage}>
      {children}
    </StyledCredit>
  )
}

export default Credit
